import styled from "styled-components";
const ForexPunishmentTable = () => {
  return (
    <Table>
      <colgroup>
        <col />
        <col />
      </colgroup>
      <thead>
        <tr>
          <th>위반사항</th>
          <th>과태료</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>외국환은행장 신고사항</td>
          <td>MAX (100만원, 위반금액의 2%)</td>
        </tr>
        <tr>
          <td>재정경제부장관, 한국은행총재 등 신고사항</td>
          <td>MAX (200만원, 위반금액의 4%)</td>
        </tr>
        <tr>
          <td>위반금액 산정이 곤란한 자본거래 신고의무</td>
          <td>200만원</td>
        </tr>
      </tbody>
    </Table>
  );
};
export default ForexPunishmentTable;
const Table = styled.table`
  width: 100%;
  border-spacing: 0;
  overflow: hidden;
  text-align: center;
  border-radius: ${({ theme }) => theme.radius};
  border: 1px solid ${({ theme }) => theme.colors.line};
  box-shadow: ${({ theme }) => theme.shadow.sm};
  & th,
  & td {
    padding: 0.9em 1.1em;
  }
  & > thead th {
    font-size: 1.2em;
    font-weight: 600;
    background-color: ${({ theme }) => theme.colors.dark};
    color: ${({ theme }) => theme.colors.foreground.inverted};
  }
  & > tbody {
    color: ${({ theme }) => theme.colors.foreground.normal};
    & > tr:nth-child(even) {
      background-color: ${({ theme }) => theme.colors.monotone.extralight};
    }
    & > tr + tr > td {
      border-top: 1px solid ${({ theme }) => theme.colors.line};
    }
  }
`;
